
import { clearSession } from '../../ConfigFiles/SharedFunctions'

const Authentication = (props) => {
    
    
  return ( (sessionStorage.getItem("signAsGuest")=='true'||sessionStorage.getItem("token")!=null)?props?.children:clearSession())
}

export default Authentication